import { all, spawn } from 'redux-saga/effects';

import watchSession from 'store/session/sagas';
import watchTasks from 'store/tasks/sagas';
import watchWritings from 'store/writings/sagas';

export default function* watcher() {
  yield all([spawn(watchSession), spawn(watchTasks), spawn(watchWritings)]);
}
